import React from 'react';
import StaticPageLayout from './StaticPageLayout';
import {
  COMPANY_LEGAL_NAME,
  CONTACT_HELP_CHECKLIST,
  CONTACT_PAGE_SECTIONS,
  CONTACT_RESPONSE_GUIDELINE,
  SUPPORT_EMAIL,
  TRUST_PAGES_LAST_UPDATED,
} from '../../constants/siteTrustContent';

const ContactPage = () => {
  return (
    <StaticPageLayout title="Contact Us">
      <p className="static-page__muted">Last updated: {TRUST_PAGES_LAST_UPDATED}</p>
      {CONTACT_PAGE_SECTIONS.map((section) => (
        <React.Fragment key={section.heading}>
          <h3>{section.heading}</h3>
          {section.paragraphs.map((paragraph, index) => (
            <p key={`${section.heading}-${index}`}>{paragraph}</p>
          ))}
        </React.Fragment>
      ))}
      <p>
        Contact email: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
      </p>
      <ul>
        {CONTACT_HELP_CHECKLIST.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <p>{CONTACT_RESPONSE_GUIDELINE}</p>
      <p className="static-page__muted">
        Operated by {COMPANY_LEGAL_NAME}. For privacy and data-use terms, see
        our Privacy and Terms pages.
      </p>
    </StaticPageLayout>
  );
};

export default ContactPage;

